import React from 'react';
import {
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
} from 'react-hook-form';
import { Button, Col, Row } from 'reactstrap';
import { InputFormField } from '../../../../../../../../components/InputFormField';
import { SelectOption } from '../../../../../../../../components/Select';
import { DepartmentService } from '../../../../../../../../services/v1/applicant_tracking/DepartmentService';
import { DepartmentValue } from '..';
import { AlertType } from '../../../../../../../../components/Alert';

interface PropTypes {
  handleSubmit: UseFormHandleSubmit<DepartmentValue>;
  register: UseFormRegister<DepartmentValue>;
  handleClose: () => void;
  isValid: boolean;
  setSelectedDepartment: (selectedOption: SelectOption) => void;
  getValues: UseFormGetValues<DepartmentValue>;
  setAlertType: (alertType: AlertType) => void;
  setAlertMessage: (message: JSX.Element) => void;
}

export function ModalBody(props: PropTypes) {
  const createDepartment = async () => {
    try {
      const department = await DepartmentService.create({
        name: props.getValues('departmentName'),
      });

      props.setSelectedDepartment({
        value: department.id.toString(),
        label: department.name,
      });
      props.setAlertType(AlertType.Success);
      props.setAlertMessage(
        <>
          <strong>{`'${department.name}'`}</strong> was created successfully
        </>,
      );
      props.handleClose();
    } catch (error) {
      props.setAlertType(AlertType.Danger);
      props.setAlertMessage(<>Department was not created successfully</>);
      props.handleClose();
    }
  };
  return (
    <div className='app-card-body px-3 w-100'>
      <Row className='mb-3'>
        <Col sm={12}>
          <InputFormField
            type={'text'}
            registerReturn={props.register('departmentName', {
              required: true,
            })}
            fieldName={'Department Name'}
            placeholder={'Add a Name'}
            isRequired={true}
            maxLength={32}
            showMaxLengthCounter={true}
          />
          <div className='d-flex justify-content-end mt-4'>
            <Button
              className='me-2'
              color='danger'
              onClick={() => props.handleClose()}
            >
              Cancel
            </Button>
            <Button
              color='primary'
              type='submit'
              disabled={!props.isValid}
              onClick={() => createDepartment()}
            >
              Create and Select Department
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}
